import { z } from 'zod'

export const MapValueSchema = z.union([z.string(), z.number(), z.boolean()]).nullish()
